// articlesStockMenu.js

import '../styles/articlesStockMenu.css';
import "../styles/loadingModal.css";

import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

import useAuth from "../components/useAuth";
import FilterField from "../components/salesFilters";
import GenericModal from "../components/filtersModal";
import LoadingModal from "../components/loadingModal";

import homeIcon from "../assets/home-icon.png";

import * as XLSX from "xlsx";

export default function ArticlesStockMenu() {

  const { userName, clientName } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Galileo Analytics - Artículos y Stock";
  }, []);

  useEffect(() => {

    obtenerUltimaSincronizacion();

  }, []);

  // =========================================================
  // MODAL
  // =========================================================

  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalData, setModalData] = useState([]);

  const [ultimaSincronizacion, setUltimaSincronizacion] = useState(null);

  const obtenerUltimaSincronizacion = async () => {

    try {

      const response = await fetch(
        "api/lastSync.php",
        {
          method: "GET",
          credentials: "include"
        }
      );
      if (response.status === 401) {
        return;
      }
      // Primero obtenemos el texto crudo
      const text = await response.text();
      //console.log("Respuesta lastSync.php:", text);
      let data;
      try {
        data = JSON.parse(text);
      } catch (parseError) {
        // console.error(
        //   "Error parseando respuesta de lastSync.php:",
        //   text
        // );

        return;
      }
      if (data.success) {
        setUltimaSincronizacion(
          data.ultimaSincronizacion
        );
      } else {
        // console.error(
        //   "Error en lastSync.php:",
        //   data.message || data.error || "Error desconocido"
        // );

      }
    } catch (error) {

      console.error(
        "Error obteniendo última sincronización:",
        error
      );

    }
  };

  const openFilterModal = async (type) => {

    setModalType(type);
    setModalTitle("Seleccionar " + type);
    setModalOpen(true);

    try {
      let response;

      if (type === "almacen") {

        response = await fetch(
          "api/articlesStockFilters.php?filter=almacen",
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              cSucursal:
                filtersState.cSucursal !== ""
                  ? filtersState.cSucursal
                  : 0
            })
          }
        );

      } else {

        response = await fetch(
          "api/articlesStockFilters.php?filter=" + type,
          {
            method: "GET",
            credentials: "include"
          }
        );

      }

      if (response.status === 401) {
        localStorage.clear();
        alert("Sesión expirada");
        navigate("/");
        return;
      }

      const text = await response.text();

      try {
        const data = JSON.parse(text);
        setModalData(data);
      } catch (jsonError) {
        console.error("JSON parse error:", text);
        setModalData([]);
      }

    } catch (error) {
      console.error("Error cargando datos:", error);
      setModalData([]);
    }
  };

  const openPeriodModal = () => {
    setModalType("period");
    setModalTitle("Período:");
    setModalData([
      { label: "Hoy", value: "hoy" },
      { label: "Esta Semana", value: "semana" },
      { label: "Este Mes", value: "mes" }
    ]);
    setModalOpen(true);
  };

  const closeFilterModal = () => {
    setModalOpen(false);
    setModalType("");
    setModalTitle("");
  };

  // =========================================================
  // FILTROS
  // =========================================================

  const filters = [

    {
      label: "Período Modif. Stock",
      type: "select",
      name: "period",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openPeriodModal()
    },

    { label: "Desde", type: "date", name: "fechaDesde" },

    { label: "Hasta", type: "date", name: "fechaHasta" },

    {
      label: "Sucursal",
      type: "text",
      name: "sucursal",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("sucursal"),
      placeholder: "Central por Defecto"
    },

    {
      label: "Almacén",
      type: "text",
      name: "almacen",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("almacen"),
      placeholder: "Todos por Defecto"
    },

    {
      label: "Rubro-Subrubro",
      type: "text",
      name: "rubro",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("rubro")
    },

    {
      label: "Artículo",
      type: "text",
      name: "articulo",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("articulo")
    },

   /* {
      label: "Proveedor",
      type: "text",
      name: "proveedor",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("proveedor")
    }*/
  ];

  const [filtersState, setFiltersState] = useState({

    fechaDesde: "",
    fechaHasta: "",

    sucursal: "Central Por Defecto",
    cSucursal: "0",

    almacen: "Todos los Almacenes",
    cAlmacen: "",

    period: "Hoy",
    periodValue: "hoy",

    rubro: "",
    cRubro: "",
    cSubRubro: "",

    articulo: "",
    cArticulo: "",

   /* proveedor: "",
    cProveedor: ""*/
  });

  const [filterMode, setFilterMode] = useState("rubro");  
  // =========================================================
  // HANDLE SELECT
  // =========================================================

  const handleSelect = (item) => {

    if (!modalType) return;

    const pick = (obj, ...keys) => {

      for (const k of keys) {

        if (obj == null) continue;

        if (Object.prototype.hasOwnProperty.call(obj, k)) {
          return obj[k];
        }
      }

      return undefined;
    };

    switch (modalType) {

      case "sucursal": {

        const text =
          pick(item, "sucursal", "SUCURSAL", "nombre", "NOMBRE");

        const val =
          pick(item, "cSucursal", "CSUCURSAL", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          sucursal: text ?? "",
          cSucursal: val ?? ""
        }));

        break;
      }

      case "almacen": {

        const text =
          pick(item, "almacen", "ALMACEN", "nombre", "NOMBRE");

        const val =
          pick(item, "cAlmacen", "CALMACEN", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          almacen: text ?? "",
          cAlmacen: val ?? ""
        }));

        break;
      }

      case "period": {

        setFiltersState(prev => ({
          ...prev,
          period: item.label,
          periodValue: item.value,
          fechaDesde: "",
          fechaHasta: ""
        }));

        break;
      }

      case "rubro": {

        const rubroName =
          pick(item, "rubro", "RUBRO");

        const subrubroName =
          pick(item, "subrubro", "SUBRUBRO");

        const cRubro =
          pick(item, "cRubro", "CRUBRO");

        const cSubRubro =
          pick(item, "cSubrubro", "CSUBRUBRO", "id");

        setFiltersState(prev => ({
          ...prev,
          rubro: `${rubroName} - ${subrubroName}`,
          cRubro: cRubro ?? "",
          cSubRubro: cSubRubro ?? ""
        }));

        break;
      }

      case "articulo": {

        const text =
          pick(item, "articulo", "ARTICULO", "nombre", "NOMBRE");

        const val =
          pick(item, "cArticulo", "CARTICULO", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          articulo: text ?? "",
          cArticulo: val ?? ""
        }));

        break;
      }

    /*  case "proveedor": {

        const text =
          pick(item, "proveedor", "PROVEEDOR", "nombre", "NOMBRE");

        const val =
          pick(item, "cProveedor", "CPROVEEDOR", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          proveedor: text ?? "",
          cProveedor: val ?? ""
        }));

        break;
      }*/

      default:
        break;
    }

    closeFilterModal();
  };

  // =========================================================
  // DATA
  // =========================================================

  const [stockData, setStockData] = useState([]);

  const [loading, setLoading] = useState(false);

const [totals, setTotals] = useState({
  stockCargado: 0,
  stockDisponible: 0,
  stockReserva: 0,
  articulos: 0
});

  // =========================================================
  // LIMPIAR FILTROS
  // =========================================================

const clearFilters = () => {

  setFiltersState({

    sucursal: "",
    cSucursal: "",

    almacen: "",
    cAlmacen: "",

    rubro: "",
    cRubro: "",
    cSubRubro: "",

    articulo: "",
    cArticulo: ""

  });

  setStockData([]);

  setTotals({

    stockCargado: 0,
    stockDisponible: 0,
    stockReserva: 0,
    articulos: 0

  });
};

  // =========================================================
  // UTILIDADES
  // =========================================================

const formatNumber = (value) => {

  return Number(value || 0).toLocaleString(
    "es-AR",
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  );

};

const formatMoney = (value) => {

  return Number(value || 0).toLocaleString(
    "es-AR",
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  );

};

  // =========================================================
  // APPLY FILTERS
  // =========================================================

const handleApplyFilters = async (e) => {

  e.preventDefault();

  setLoading(true);
  setStockData([]);

  const filtros = {

    fechaDesde: filtersState.fechaDesde || null,
    fechaHasta: filtersState.fechaHasta || null,

    period: filtersState.periodValue || null,

    cSucursal:
      filtersState.cSucursal || null,

    cAlmacen:
      filtersState.cAlmacen || null,

    // cRubro:
    //   filtersState.cRubro || null,

    cSubRubro:
      filtersState.cSubRubro || null,

    cArticulo:
      filtersState.cArticulo || null

  };

  if (!filtersState.cSucursal) {

    alert("Debe seleccionar una sucursal.");

    return;
  }

  try {

    const response = await fetch(
      "api/articlesStockList.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify(filtros)
      }
    );

    if (response.status === 401) {

      localStorage.clear();

      alert("Sesión expirada");

      navigate("/");

      return;
    }

    const text = await response.text();

    let data;

    try {

      data = JSON.parse(text);

    } catch (e) {

      console.error(
        "Error parseando JSON:",
        text
      );

      setLoading(false);

      return;
    }

    const ordered =
      Array.isArray(data)
        ? [...data]
        : [];

    setStockData(ordered);

    const sum = (field) =>
      ordered.reduce(
        (acc, item) =>
          acc +
          (parseFloat(item[field]) || 0),
        0
      );

    setTotals({

      stockCargado:
        sum("STOCK_CARGADO"),

      stockDisponible:
        sum("STOCK_DISPONIBLE"),

      stockReserva:
        sum("STOCK_RESERVA"),

      articulos:
        ordered.length

    });

  } catch (error) {

    console.error(
      "Error al obtener stock:",
      error
    );

  } finally {

    setLoading(false);

  }
};

  // =========================================================
  // EXPORT EXCEL
  // =========================================================

const exportToExcel = () => {

  if (!stockData || stockData.length === 0) {

    alert("No hay datos para exportar.");

    return;
  }

  const headers = [

    "Sucursal",
    "Almacén",
    "Cod. Artículo",
    "Artículo",

    "Stock Cargado",
    "Stock Reserva",
    "Stock Disponible",

    // "Costo",
    // "Precio 1",
    // "Precio 2",
    // "Precio 3",
    // "Precio 4",

    "F. Act. Precios",
    "F. Act. Stock",
  ];

  const rows = stockData.map(row => [

    row.SUCURSAL,
    row.ALMACEN,
    Number(row.CARTICULO),
    row.DESC_CORTA,

    Number(row.STOCK_CARGADO),
    Number(row.STOCK_RESERVA),
    Number(row.STOCK_DISPONIBLE),

    // Number(row.COSTO),
    // Number(row.PRECIO1),
    // Number(row.PRECIO2),
    // Number(row.PRECIO3),
    // Number(row.PRECIO4),

    row.ULT_ACT_PRECIO,
    row.FMODI

  ]);

  const wb = XLSX.utils.book_new();

  const ws = XLSX.utils.aoa_to_sheet([
    headers,
    ...rows
  ]);

  XLSX.utils.book_append_sheet(
    wb,
    ws,
    "Stock"
  );

  XLSX.writeFile(
    wb,
    "Galileo-Analytics-Stock.xlsx"
  );
};

// =========================================================
// RENDER
// =========================================================

return (
  <>
    <div className="sales-menu">
      <aside className="filters-section">
        <div className="filters-header">
          <button
            type="button"
            className="home-button"
            onClick={() => navigate("/menu")}
          >
            <img src={homeIcon} alt="Home" />
          </button>
        </div>
        <h2>Filtros</h2>
        <form
          className="sales-filters-form"
          onSubmit={handleApplyFilters}
        >
          <div className="article-filter-mode">

            <label>
              <input
                type="radio"
                name="filterMode"
                value="rubro"
                checked={filterMode === "rubro"}
                onChange={() => {
                  setFilterMode("rubro");

                  setFiltersState(prev => ({
                    ...prev,
                    articulo: "",
                    cArticulo: ""
                  }));
                }}
              />
              Rubro/Subrubro
            </label>

            <label>
              <input
                type="radio"
                name="filterMode"
                value="articulo"
                checked={filterMode === "articulo"}
                onChange={() => {
                  setFilterMode("articulo");

                  setFiltersState(prev => ({
                    ...prev,
                    rubro: "",
                    cRubro: "",
                    cSubRubro: ""
                  }));
                }}
              />
              Artículo
            </label>

          </div>

          <div className="filters-body">

            {filters
              .filter((f) => {

                if (
                  filterMode === "rubro" &&
                  f.name === "articulo"
                ) {
                  return false;
                }

                if (
                  filterMode === "articulo" &&
                  f.name === "rubro"
                ) {
                  return false;
                }

                return true;
              })
              .map((f) => {

                let hiddenVal = "";

                if (f.name === "sucursal") {

                  hiddenVal =
                    filtersState.cSucursal || "";
                }
                else if (f.name === "almacen") {

                  hiddenVal =
                    filtersState.cAlmacen || "";
                }
                else if (f.name === "rubro") {

                  hiddenVal = JSON.stringify({
                    cRubro:
                      filtersState.cRubro || "",

                    cSubRubro:
                      filtersState.cSubRubro || ""
                  });
                }
                else if (f.name === "articulo") {

                  hiddenVal =
                    filtersState.cArticulo || "";
                }
                return (
                  <FilterField
                    key={f.name}
                    {...f}
                    value={
                      filtersState[f.name] || ""
                    }
                    hiddenValue={hiddenVal}
                    onChange={(e) => {

                      const value =
                        e.target.value;

                      setFiltersState(prev => ({
                        ...prev,
                        [f.name]: value,

                        ...(f.name === "fechaDesde" ||
                          f.name === "fechaHasta"
                          ? {
                              period: "",
                              periodValue: ""
                            }
                          : {})
                      }));
                    }}
                  />
                );
              })}
          </div>
          <button
            type="submit"
            className="filter-button"
          >
            Aplicar filtros
          </button>

          <button
            type="button"
            className="delete-filter-button"
            onClick={clearFilters}
          >
            Borrar filtros
          </button>

          <button
            type="button"
            className="export-excel-button"
            onClick={exportToExcel}
          >
            Exportar Datos
          </button>

          <div className="sync-info">
            <span>
              Última sincronización:{" "}
              {ultimaSincronizacion || "Sin datos"}
            </span>
          </div>

        </form>
      </aside>
      {/* =====================================================
          DATOS
      ===================================================== */}
      <main className="sales-data">
        {/* ===================================================
            TARJETAS RESUMEN
        =================================================== */}
        <div className="stats-cards">{/*abre DIV*/}

          <div className="stat-card">
            <span>Artículos</span>
            <h2>
              {stockData.length}
            </h2>
          </div>
          <div className="stat-card">
            <span>Stock Cargado</span>
            <h2>
              {formatMoney(
                stockData.reduce(
                  (acc, item) =>
                    acc +
                    Number(
                      item.STOCK_CARGADO || 0
                    ),
                  0
                )
              )}
            </h2>
          </div>

          <div className="stat-card">
            <span>Stock en Reserva</span>
            <h2>
              {formatMoney(
                stockData.reduce(
                  (acc, item) =>
                    acc +
                    Number(
                      item.STOCK_RESERVA || 0
                    ),
                  0
                )
              )}
            </h2>
          </div>

          <div className="stat-card">
            <span>Stock Disponible</span>
            <h2>
              {formatMoney(
                stockData.reduce(
                  (acc, item) =>
                    acc +
                    Number(
                      item.STOCK_DISPONIBLE || 0
                    ),
                  0
                )
              )}
            </h2>
          </div>
        </div> {/*cierre DIV*/}

        {/* <div className="stats-cards">

          <div className="stat-card">
            <span>Valorización Costo</span>
            <h2>
              {formatMoney(
                stockData.reduce(
                  (acc, item) =>
                    acc +
                    (
                      Number(item.STOCK_DISPONIBLE || 0) *
                      Number(item.COSTO || 0)
                    ),
                  0
                )
              )}
            </h2>
          </div>

          <div className="stat-card">
            <span>Valorización Precio 1</span>
            <h2>
              {formatMoney(
                stockData.reduce(
                  (acc, item) =>
                    acc +
                    (
                      Number(item.STOCK_DISPONIBLE || 0) *
                      Number(item.PRECIO1 || 0)
                    ),
                  0
                )
              )}
            </h2>
          </div>

          <div className="stat-card">
            <span>Valorización Precio 2</span>
            <h2>
              {formatMoney(
                stockData.reduce(
                  (acc, item) =>
                    acc +
                    (
                      Number(item.STOCK_DISPONIBLE || 0) *
                      Number(item.PRECIO2 || 0)
                    ),
                  0
                )
              )}
            </h2>
          </div>

          <div className="stat-card">
            <span>Valorización Precio 3</span>
            <h2>
              {formatMoney(
                stockData.reduce(
                  (acc, item) =>
                    acc +
                    (
                      Number(item.STOCK_DISPONIBLE || 0) *
                      Number(item.PRECIO3 || 0)
                    ),
                  0
                )
              )}
            </h2>
          </div>

          <div className="stat-card">
            <span>Valorización Precio 4</span>
            <h2>
              {formatMoney(
                stockData.reduce(
                  (acc, item) =>
                    acc +
                    (
                      Number(item.STOCK_DISPONIBLE || 0) *
                      Number(item.PRECIO4 || 0)
                    ),
                  0
                )
              )}
            </h2>
          </div>

        </div> */}
        {/* ===================================================
            TABLA DE STOCK
        =================================================== */}
        <div className="summary-card stock-summary-card">
          <div className="summary-card-header">
            <h3>
              Stock de Artículos
            </h3>
          </div>
          <div className="top-products-table stock-table">
            <table>
              <thead>
                <tr>
                  <th>Sucursal</th>
                  <th>Almacén</th>
                  <th>Artículo</th>
                  <th>Stock Cargado</th>
                  <th>Stock Reserva</th>
                  <th>Stock Disponible</th>
                  {/* <th>Costo</th>
                  <th>Precio 1</th>
                  <th>Precio 2</th>
                  <th>Precio 3</th>
                  <th>Precio 4</th> */}
                  <th>F. Act. Precios</th>
                  <th>F. Act. Stock</th>
                </tr>

              </thead>
              <tbody>
                {stockData.length === 0 ? (
                  <tr>
                    <td
                      colSpan="11"
                      className="empty-table-message"
                    >
                      No hay datos para mostrar.
                    </td>
                  </tr>
                ) : (
                  stockData.map((item, idx) => (

                    <tr key={idx}>

                      <td>
                        {item.SUCURSAL || "-"}
                      </td>

                      <td>
                        {item.ALMACEN || "-"}
                      </td>

                      <td>

                        <strong>
                          {item.CARTICULO || "-"}
                        </strong>

                        <br />

                        <span className="article-description">
                          {item.DESC_CORTA || ""}
                        </span>

                      </td>

                      <td>
                        {formatMoney(
                          item.STOCK_CARGADO
                        )}
                      </td>

                      <td>
                        {formatMoney(
                          item.STOCK_RESERVA
                        )}
                      </td>

                      <td>
                        {formatMoney(
                          item.STOCK_DISPONIBLE
                        )}
                      </td>

                      {/* <td>
                        ${formatMoney(
                          item.COSTO
                        )}
                      </td>

                      <td>
                        ${formatMoney(
                          item.PRECIO1
                        )}
                      </td>

                      <td>
                        ${formatMoney(
                          item.PRECIO2
                        )}
                      </td>

                      <td>
                        ${formatMoney(
                          item.PRECIO3
                        )}
                      </td>

                      <td>
                        ${formatMoney(
                          item.PRECIO4
                        )}
                      </td> */}

                      <td>
                        {item.ULT_ACT_PRECIO
                          ? new Date(
                              item.ULT_ACT_PRECIO
                            ).toLocaleDateString(
                              "es-AR"
                            )
                          : "-"
                        }
                      </td>

                      <td>
                        {item.FMODI
                          ? new Date(
                              item.FMODI
                            ).toLocaleDateString(
                              "es-AR"
                            )
                          : "-"
                        }
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>

    {/* =====================================================
        FOOTER
    ===================================================== */}

    <div className="sales-menu-footer">

      <div className="footer-left-logo">

        <img
          className="footer-system-logo"
          src={`${process.env.PUBLIC_URL}/logos/galileoinsight-logo.png`}
          alt="Logo Sistema"
        />

      </div>

      <footer>

        <span>
          Sesión Actual: {userName} | {clientName}
        </span>

      </footer>

    </div>

    <GenericModal
      title={modalTitle}
      isOpen={modalOpen}
      data={modalData}
      onSelect={handleSelect}
      onClose={closeFilterModal}
    />

    <LoadingModal
      open={loading}
    />

  </>
);
}